import { faPen, faTrash, faQuestionCircle, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../Auth/AuthContext'
import { Table, Button,Row,Col,Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext';
import { TablePagination, Loading } from '../Library';
import { AlertModalContext } from '../Library/AlertModalContext'
import { NotifyContext } from '../Library/Notify'
import "./UserLinkroom.css"
import axios from 'axios'
import DatePicker from "react-datepicker";

function Bookings(props) {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const lang = langCx.lang.linkroom
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const [visitorReportList, setVisitorReportList] = useState([])
    const [companyName, setCompanyName] = useState("")
    const [page, setPage] = useState(1)
    const size = 10
    const [count, setCount] = useState(0)
    const [securityVisitor, setSecurityVisitor] = useState([])
    const [bookingList, setBookingList] = useState([])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null) 

    useEffect(() => {
        const fetchUserList = async () => {
            if (!props.token) return;
    
            try {
                setIsLoading(true)
                console.log('Token : ', props.token)
                const headers = {
                    'Authorization': props.token,
                };
                const bookingListData = await axios.post(
                    'https://visitor-api.lifelink.co.th:10443/linkroom/api/v1/listallbooking',
                    null,
                    { headers }
                );
                console.log(bookingListData.data.data)
                setBookingList(Array.isArray(bookingListData.data.data) ? bookingListData.data.data.flat() : []);
                setIsLoading(false)
            } catch (e) {
                console.error(e);
                setIsLoading(false)
            }
        };
    
        fetchUserList();
    }, [props.token]);
        

    const formattedDate = (date) => {
        const dateFormatted = dayjs(date).format("D MMM YYYY - H:mm")
        return dateFormatted
    }

    const BookingListItem = ({ topic,roomname,timestart,timeend, useremail, username }) => {
        return(
            <tr>
                <td></td>
                <td>{topic}</td>
                <td>{roomname}</td>
                <td>{username}</td>
                <td>{dayjs(timestart).format("DD-MM-YYYY HH:mmน.") +' - '+ dayjs(timeend).format("DD-MM-YYYY HH:mmน.")}</td>
                <td>{username}</td>
                <td>{useremail}</td>
                <td>
                    {/*
                    <div className="action-container">
                        <Button size="sm"
                        onClick={onEditClick}>
                            <FontAwesomeIcon icon={faPen}/>
                        </Button>
                        <Button size="sm" variant="danger" style={{marginLeft: 10}}
                        onClick={onDeleteClick}>
                            <FontAwesomeIcon icon={faTrash}/>
                        </Button> 
                    </div>
        */}
                </td>
            </tr>
        )
    }

    return(
        <div id="visitor-report">
            { isLoading ? <Loading/> : null }
            <div className="button-container">
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div>{lang.linkroombooking}</div>
                    
                </div>
            </div>
            {/*
            <div>
            <Row>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่เริ่มต้น'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่เริ่มต้น'}
                                maxDate={new Date()}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่สิ้นสุด'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>{
                                    setEndDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่สิ้นสุด'}
                                maxDate={new Date()}
                                minDate={startDate}
                                />
                                </div>
                            </Form.Group>
                </Col>
            </Row>
            </div>
            */}
            
            <div className='table-container'>
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.topic}</th>
                            <th>{lang.roomname}</th>
                            <th>{lang.usernameBooking}</th>
                            <th>{lang.timeBooking}</th>
                            <th>{lang.usernameBooking}</th>
                            <th>{lang.emailBooking}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { bookingList.map((item, key) =>
                        <BookingListItem
                        key={key}
                        topic={item.topic}
                        firstname={item.firstname}
                        roomname={item.roomname}
                        timestart={item.date_time_use}
                        timeend={item.date_time_end}
                        useremail={item.useremail}
                        username={item.username}
                        //onEditClick={()=>history.push("/visitor_security/edit/"+item.security_id)}
                        //onDeleteClick={()=>deleteSecureFromList(item.security_id, item.security_name)}
                        />
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default Bookings;
